(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-upgrade-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[data-upgrade-variant]');
    if (!(link instanceof HTMLAnchorElement)) return;
    const picker = link.closest('variant-picker');
    if (!picker || picker.closest('product-card, quick-add-dialog')) return;
    const variantId = link.dataset.upgradeVariant;
    const radio = Array.from(picker.querySelectorAll('input[type="radio"][data-variant-id]')).find((input) => input.dataset.variantId === variantId);
    if (radio instanceof HTMLInputElement && !radio.disabled && radio.getAttribute('aria-disabled') !== 'true') {
      event.preventDefault();
      radio.click();
      return;
    }
    const option = Array.from(picker.querySelectorAll('select option[data-variant-id]')).find((item) => item.dataset.variantId === variantId);
    if (option instanceof HTMLOptionElement && !option.disabled && option.parentElement instanceof HTMLSelectElement && !option.parentElement.disabled) {
      event.preventDefault();
      option.parentElement.value = option.value;
      option.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  } catch(e) { console.error(e); }
})();

})();
